export const HISTOLOGIA_FINALIZADA = 'HISTOLOGIA_FINALIZADA';
export const histologiaFinalizada = (histologiaFinalizada) => ({
  type: HISTOLOGIA_FINALIZADA,
  payload: {
    histologiaFinalizada: histologiaFinalizada,
  },
});



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/histo/histo.action.js